import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";

export interface IQuestionsEditableResponse {
  editable: boolean;
  progress_count: number;
}

export const getQuestionsEditable = async (examPaperId: string) => {
  const response = await apiGet<IQuestionsEditableResponse>(
    `/exam_papers/${examPaperId}/questions_editable`
  );
  return response.data;
};

export const useQueryGetQuestionsEditable = (
  examPaperId: string,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: QueryKeys.examPaper.questionsEditable(examPaperId),
    queryFn: () => getQuestionsEditable(examPaperId),
    enabled: !!examPaperId && options?.enabled !== false,
  });
};
